import { formatDistanceToNow } from '../../lib/relativeTime'
import type { CurrentShoppingList } from '../../hooks/useCurrentShoppingList'

type Props = {
  list:            NonNullable<CurrentShoppingList>
  onStartShopping: () => void
  onViewList:      () => void
}

export function CurrentListCard({ list, onStartShopping, onViewList }: Props) {
  const shownChips    = list.items.slice(0, 3)
  const overflow      = list.items.length - shownChips.length
  const updatedLabel  = formatDistanceToNow(list.generatedAt)

  return (
    <section className="relative mb-[14px] overflow-hidden rounded-[18px] bg-forest p-4 text-forest-ink">
      <div className="mb-2 flex items-baseline justify-between">
        <span className="text-[10px] font-medium uppercase tracking-[0.15em] text-sand">
          Current list
        </span>
        <span className="text-[11px] opacity-70">Updated {updatedLabel}</span>
      </div>

      <h2 className="font-serif text-[22px] font-normal leading-[1.15] tracking-[-0.005em]">
        {list.itemCount} {list.itemCount === 1 ? 'item' : 'items'}{' '}
        <em className="italic text-sand">queued up</em>
      </h2>

      <div className="mt-[10px] flex flex-wrap gap-1">
        {shownChips.map(item => (
          <span
            key={item.id}
            className="rounded-[6px] bg-white/15 px-2 py-[3px] text-[10px] font-medium text-forest-ink"
          >
            {item.name}
          </span>
        ))}
        {overflow > 0 && (
          <span className="rounded-[6px] bg-white/15 px-2 py-[3px] text-[10px] font-medium text-forest-ink">
            + {overflow} more
          </span>
        )}
      </div>

      <div className="mt-[14px] flex gap-[6px]">
        <button
          onClick={onStartShopping}
          className="flex-1 rounded-[10px] bg-cream px-3 py-[10px] text-[12px] font-bold tracking-[-0.01em] text-forest"
        >
          Start shopping
        </button>
        <button
          onClick={onViewList}
          className="rounded-[10px] border border-white/35 px-3 py-[10px] text-[12px] font-medium text-forest-ink"
        >
          View
        </button>
      </div>
    </section>
  )
}
